import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { useField } from "formik";

import RpDatePicker from "@/components/muiCustom/date/RpDatePicker";
import { rrdDirectMailCampaignHelper } from "@/features/campaigns/direct-mail/rrd/utils/rrdDirectMailHelper";

const DatePicker = RpDatePicker as React.ElementType;

function RRDDirectBackCouponExpInput({
  name = "back_coupon_expiry_date",
  mailingDateFieldName = "mailing_date",
  differentCouponExpiryFieldName = "different_coupon_expiry",
  containerClassName = "",
  expiryDateConstraints,
}) {
  const [couponExpiryField, , couponExpiryHelpers] = useField(name);

  const [mailingDateField] = useField(mailingDateFieldName);

  const [differentCouponExpiryField] = useField(differentCouponExpiryFieldName);

  useEffect(() => {
    const nextValue =
      rrdDirectMailCampaignHelper.getConstrainedCouponExpiryValue(
        couponExpiryField.value,
        expiryDateConstraints
      );

    if (nextValue !== couponExpiryField.value) {
      couponExpiryHelpers.setValue(nextValue);
    }
  }, [couponExpiryField.value, couponExpiryHelpers, expiryDateConstraints]);

  const handleOnCouponExpiryChange = (d) => {
    const value = d ? d.format("YYYY-MM-DD") : "";
    couponExpiryHelpers.setValue(value);
  };

  if (!differentCouponExpiryField.value) {
    return null;
  }

  return (
    <>
      <Typography
        variant="body2"
        component="span"
        gutterBottom
        fontWeight={600}
        className="mb-2"
        sx={{ display: "block", lineHeight: 1.35 }}
      >
        Back Coupon Expiration Date
      </Typography>
      <DatePicker
        name={name}
        containerClassName={containerClassName}
        value={couponExpiryField.value}
        onChange={handleOnCouponExpiryChange}
        borderColor="var(--primary-base)"
        hideCalendarIcon
        highlightWeekDaysOnly
        minDate={expiryDateConstraints.minCouponExpiryDate}
        maxDate={expiryDateConstraints.maxCouponExpiryDate}
        disabled={!mailingDateField.value}
        format="MMM DD, YYYY"
        smallSize={true}
      />
    </>
  );
}

export default RRDDirectBackCouponExpInput;
